import React from 'react';
import WithAccordion from '../../customComponents/CustomAccordion';
import PaddingComponent from '../../customComponents/PaddingComponent';
import Border, { IBorderValueProps } from '../../../puck/reusable-props/Border';
import { PaddingType } from '../../../puck/reusable-props/padding';
import BackgroungColorComponent, {
  IBackgroundProps,
} from '../../customComponents/BackgroungColorComponent';
import { Switch } from '@mui/material';
import NewMarginFiled from '../../../puck/reusable-props/newMarginField';
import { MarginType } from '../../../puck/reusable-props/NewMargin';

export interface QuantityOptionsProps {
  border: IBorderValueProps;
  margin: MarginType;
  padding: PaddingType;
  showQuantity: boolean;
  background: IBackgroundProps;
}

interface IQuantityOptionsProps {
  value: QuantityOptionsProps;
  onChange: (_value: QuantityOptionsProps) => void;
  title?: string;
}

const QuantityOptions = ({
  value,
  onChange,
  title = 'Quantity Options',
}: IQuantityOptionsProps): React.ReactElement<QuantityOptionsProps> => {
  return (
    <>
      <WithAccordion title={title}>
        <div className="flex justify-between items-center mb-3">
          <p className="text-sm font-semibold">Show Quantity</p>
          <div className="flex gap-0.5 items-center">
            <Switch
              checked={value?.showQuantity}
              onChange={e =>
                onChange({
                  ...value,
                  showQuantity: e.target.checked,
                })
              }
            />
          </div>
        </div>
        {value?.showQuantity && (
          <>
            <NewMarginFiled
              value={value?.margin}
              onChange={margin => {
                onChange({ ...value, margin });
              }}
              title="Margin"
            />
            <PaddingComponent
              value={value?.padding}
              onChange={padding => {
                onChange({ ...value, padding });
              }}
              title="Padding"
            />
            <Border
              value={value?.border}
              onChange={border => {
                onChange({ ...value, border });
              }}
              title="Border"
            />
            <BackgroungColorComponent
              value={value?.background}
              onChange={background => {
                onChange({ ...value, background });
              }}
              title="Background"
            />
          </>
        )}
      </WithAccordion>
    </>
  );
};

export default QuantityOptions;
